import { Dispatch } from 'redux';
import { Action } from '../cases/types';
import { setCaseErrors } from 'modules/cm/store/cases/caseErrors/actions';
import { CaseError } from 'modules/cm/domain/Case/Error';
import { Nullable } from 'utils/types';

const setCaseErrorsUseCase = (caseErrors: Nullable<CaseError>) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(setCaseErrors(caseErrors));
  };
};

export default setCaseErrorsUseCase;
